module.exports = __webpack_public_path__ + "f936b7505014db4cee7b30487839d642.jpg";